import { taskHash } from "@/context/RoadmapContext";
import { TaskRow } from "./TaskRow";

export function Checklist({ items, idPrefix, tab = "Autre" }) {
  return (
    <ul className="checklist mb-0">
      {items.map((item, i) => {
        const id = taskHash(item + "-" + idPrefix + "-" + i);
        return (
          <li key={i}>
            <TaskRow taskId={id} label={item.replace(/<[^>]*>/g, "").substring(0, 200)} tab={tab}>
              <span dangerouslySetInnerHTML={{ __html: item }} />
            </TaskRow>
          </li>
        );
      })}
    </ul>
  );
}

export function CompletionBar({ containerId }) {
  const { taskStatuses } = useRoadmap();
  // Count tasks by scanning all task IDs that start with the expected pattern
  // We rely on the parent to pass total/done counts instead
  return null; // Placeholder - completion is computed at tab level
}
